module.exports = __webpack_public_path__ + "media/images/admin/icons/image-f5cc00966ad4fe5f0b2504daf41e122b.svg";